export default __webpack_public_path__ + "static/media/nie-logo-white.a431fafa.png";